import { of } from 'rxjs'

import { epicRequest, reducersMerge, reduxFetchCreator, serverResponse } from 'app'

import type { ServerResponseSchema } from 'app'
import type { FixtureSchema } from 'institutions'

export interface FetchAction {
  blocked?: boolean
  fixture: File
  institutionId: string
}

const getInitialState = () =>
  serverResponse<ServerResponseSchema<FixtureSchema[]>[]>({
    data: [],
  })

const upload = reduxFetchCreator<'fixturesUpload', FetchAction, ReturnType<typeof getInitialState>>(
  'fixturesUpload',
  getInitialState(),
  {
    error: (state, action) => {
      const fileFound = state.data.find(({ key }) => key === action.payload.originalAction?.payload.fixture.name)
      if (fileFound) {
        fileFound.error = action.payload.error
        fileFound.loading = false
        fileFound.loaded = false
      }
    },
    fulfilled: (state, action) => {
      const fileFound = state.data.find(({ key }) => key === action.payload.originalAction?.payload.fixture.name)
      if (fileFound) {
        Object.assign(fileFound, action.payload, { loaded: true, loading: false })
      }
    },
    start: (state, action) => {
      const fileFound = state.data.find(({ key }) => key === action.payload.fixture.name)
      if (fileFound) {
        if (fileFound.loading) {
          action.payload.blocked = true
        } else {
          fileFound.loading = true
          fileFound.loaded = false
        }
      } else {
        state.data.push(
          serverResponse<FixtureSchema[]>(
            {
              key: action.payload.fixture.name,
            },
            { loading: true },
          ),
        )
      }
    },
  },
)

const fixturesUploadEpic = epicRequest({
  actionType: upload.actions.fixturesUpload.type,
  errorAction: upload.actions.fixturesUploadError,
  fulfilledAction: upload.actions.fixturesUploadFulfilled,
  overlap: true,
  // @ts-ignore
  request: ({ payload }: { payload: FetchAction }) => {
    if (payload.blocked) {
      return of(
        upload.actions.fixturesUploadError({
          // @ts-ignore
          error: { code: 403, message: 'File is already being uploaded' },
        }),
      )
    }
    const formData = new FormData()
    formData.append('fixture', payload.fixture)
    formData.append('institutionId', payload.institutionId)

    return {
      body: formData,
      method: 'post',
      url: 'import/fixture',
    }
  },
  untilTypes: upload.actions.fixturesUploadCancel.type,
})

export const actions = {
  ...upload.actions,
}

export const epics = [fixturesUploadEpic]

export const reducer = reducersMerge(upload.reducer) as typeof upload.reducer
